let header = document.querySelectorAll(".header")[0]
let headerBtn = document.querySelectorAll(".header__menu")[0]
let headerLists = document.querySelectorAll(".header__list")[0]
let headerList = document.querySelectorAll(".list")

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
})

headerLists.addEventListener("click", (e) => {
    if (e.target != e.currentTarget)
        return; //子要素がクリックされたら無視
    header.classList.toggle("is-on");
})

headerList.forEach(list => {
    list.addEventListener("click", () => {
        header.classList.toggle("is-on");
    })
});